import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ICompany } from 'identity-webapi-client';
import { ListRangesRequest, ListRangesResponse, Range, ResourceType } from 'situview-webapi-client';
import { RangeService } from 'src/app/services';

@Component({
  selector: 'range-list',
  templateUrl: './range-list.component.html',
  styleUrls: ['./range-list.component.less']
})
export class RangeListComponent implements OnInit, OnChanges {
  @Input() isDarkMode: boolean = false;
  @Input() company: ICompany | undefined;
  @Input() admin: boolean = false;

  viewControls = {
    pageIndex: 0,
    pageSize: 50,
    totalItems: 0,
    pageSizeOptions: [25, 50, 100]
  } as RangesListViewControls;


  loading: boolean = false;
  rangeDataSource = new MatTableDataSource<Range>();
  searchTerm = "";

  constructor(
    private router: Router,
    private rangeService: RangeService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.loadRanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.company) {
      this.loadRanges();
    }
  }

  onPageChange(event: PageEvent) {
    this.viewControls.pageSize = event.pageSize;
    this.viewControls.pageIndex = event.pageIndex;

    this.loadRanges();
  }

  onClickRange(range: Range) {
    if (this.canBeEdited(range)) {
      this.router.navigate(['products/ranges', range.id]);
    } else {
      return;
    }
  }

  canBeEdited(range: Range) {
    return !(range?.logicalExpression && (range?.name === "Unassigned"));
  }

  loadRanges() {
    this.loading = true;

    let request = new ListRangesRequest();
    request.companyId = this.company?.id;
    request.includeDeleted = true;
    request.resourceType = ResourceType.Product;
    request.searchTerm = this.searchTerm;
    request.pageNumber = this.viewControls.pageNumber;
    request.pageSize = this.viewControls.pageSize;

    return this.rangeService.ListRanges(request)
      .then((response: any) => {
        let listRangesResponse = response as ListRangesResponse;
        if (listRangesResponse.success) {
          this.rangeDataSource.data = response.items ?? [];
          this.viewControls.totalItems = response.totalItems ?? 0;
        } else {
          this.showMessage("There was an issue retrieving ranges!");
        }
        this.loading = false;
      })
      .catch((err: any) => {
        this.loading = false;
        this.showMessage("Could not retrieve ranges!");
      });
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}

interface RangesListViewControls {
  pageSize: number;
  pageIndex: number;
  pageNumber: number;
  totalItems: number;
  pageSizeOptions: number[];
}